import React from "react";
import { Users } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const FestivalExperience: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className="section bg-gray-50 overflow-hidden">
      <div className="container-custom">
        {/* Pentru toate vârstele */}
        <div className="bg-gradient-to-br from-romanian-blue to-primary-700 rounded-3xl p-8 md:p-12 text-white mb-12 md:mb-16 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-romanian-yellow/10 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-romanian-red/10 rounded-full blur-3xl" />

          <div className="relative z-10 max-w-4xl mx-auto text-center">
            <Users className="w-16 h-16 text-romanian-yellow mx-auto mb-6" />
            <h2 className="font-display text-3xl md:text-4xl font-bold mb-6">
              {t.experience.forAllAges}
            </h2>
            <p className="text-white/90 text-lg leading-relaxed mb-6">
              {t.experience.forAllAgesDesc1}
            </p>
            <p className="text-white/90 text-lg leading-relaxed mb-6">
              {t.experience.forAllAgesDesc2}
            </p>
            <p className="text-romanian-yellow text-xl font-semibold">
              {t.experience.generations}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FestivalExperience;
